var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{class:_vm.classes || 'border-grey-700 h-px w-full my-4'})
}
var staticRenderFns = []

export { render, staticRenderFns }